import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/layout/Common";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import WidgetLogin from "@/pages/auth/WidgetLogin";
import AdminPlugin from "@/pages/admin/AdminPlugin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Dashboard from "@/pages/Dashboard";
import Agent from "@/pages/Agent";
import Favorites from "@/pages/Favorites";
import Documents from "@/pages/Documents";
import Profile from "@/pages/Profile";
import CVTool from "@/pages/tools/CVTool";
import CoverLetterTool from "@/pages/tools/CoverLetterTool";
import Predictor from "@/pages/tools/Predictor";
import Orientation from "@/pages/tools/Orientation";

function Root() {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-orange animate-pulse" />
          <span className="text-sm text-muted-foreground">Loading…</span>
        </div>
      </div>
    );
  }
  return user ? <Navigate to="/dashboard" replace /> : <Login />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/widget-login" element={<WidgetLogin />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/agent" element={<Agent />} />
          <Route path="/favorites" element={<ProtectedRoute><Favorites /></ProtectedRoute>} />
          <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/tools/cv" element={<ProtectedRoute><CVTool /></ProtectedRoute>} />
          <Route path="/tools/cover-letter" element={<CoverLetterTool />} />
          <Route path="/tools/predictor" element={<Predictor />} />
          <Route path="/tools/orientation" element={<Orientation />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/plugin" element={<ProtectedRoute><AdminPlugin /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
